export const SET_LOADS = "SET_LOADS"
